import React from "react";
import { Box, Stack, Typography, Card, CardMedia, CardContent, Button, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Badge de estado: única aplicación de la esquina 45° (IDENTIDAD_VISUAL.md §6)
const badgeSx = {
  borderRadius: "4px",
  clipPath: "polygon(6px 0, 100% 0, 100% 100%, 0 100%, 0 6px)",
  fontSize: "0.75rem",
  letterSpacing: "0.08em",
  textTransform: "uppercase",
};

const EventNeonCard = ({ event }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/events/${event.EventID}`);
  };

  const cuposDisponibles = event.CupoMaximo - event.Registrados;

  return (
    <Card
      name="Event"
      id={event.EventID}
      onClick={handleCardClick}
      sx={{ width: 300, cursor: "pointer" }}
    >
      <CardMedia
        component="img"
        image={event.MainPicture || "/images/placeholder-event.webp"}
        alt={event.EventName}
        onError={(e) => {
          if (!e.target.src.endsWith("/images/placeholder-event.webp")) {
            e.target.src = "/images/placeholder-event.webp";
          }
        }}
        sx={{ aspectRatio: "16/9", objectFit: "cover", backgroundColor: "#0A0A12" }}
      />
      <CardContent>
        <Stack spacing={1} alignItems="flex-start" sx={{ textAlign: "left" }}>
          {(event.CupoLimitado || event.RequiereEntradas) && (
            <Stack direction="row" spacing={1}>
              {event.CupoLimitado && (
                <Chip size="small" label="Cupo limitado" sx={{ ...badgeSx, bgcolor: "warning.main", color: "#0A0A12" }} />
              )}
              {event.RequiereEntradas && (
                <Chip size="small" label="Requiere entrada" sx={badgeSx} />
              )}
            </Stack>
          )}
          <Typography variant="h3" component="h3">
            {event.EventName}
          </Typography>
          <Box>
            <Typography variant="body2" color="text.secondary">
              {event.EventDate} · {event.Horario}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {event.Lugar}
            </Typography>
            {event.CupoLimitado && (
              <Typography variant="body2" color="text.secondary">
                Quedan {cuposDisponibles} cupos
              </Typography>
            )}
          </Box>
          <Button variant="contained" onClick={handleCardClick}>
            Registrarse
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default EventNeonCard;
